import { getDocuments } from '../../api/documents'
import getToken from '../account/getToken'

const hydrateDocuments = store => async () => {
  const {
    documentCenterPage,
    documentCenterSortBy,
    documentCenterSortDirection,
    documentCenterSearch,
    documentCenterFilters,
  } = store.getState()
  let token

  try {
    token = await getToken(store)()
    // No token
    if (!token) {
      store.setState({
        isHydratingDocuments: false,
      })
      return
    }
  } catch (err) {
    return
  }


  store.setState({
    isHydratingDocuments: true,
  })

  // refresh token if necessary

  return getDocuments({
    token,
    page: documentCenterPage,
    sortBy: documentCenterSortBy,
    sortDirection: documentCenterSortDirection,
    search: documentCenterSearch,
    filters: documentCenterFilters,
  })
    .then(res => {
      if (!res.ok) {
        throw res
      } else {
        return res.json()
      }
    })
    .then(({ documents, totalDocuments }) => {
      // Hydrate documents
      store.setState({
        documents,
        totalDocuments,
        isHydratingDocuments: false,
      })
    })
    .catch(error => {
      console.log(error)
      store.setState({
        isHydratingDocuments: false,
      })
    })
}

export default hydrateDocuments
